import { isEqualStatoScommessaByKey } from 'features/ippica/functions';
import { selectStatoAvvenimento } from 'features/ippica/selectors';
import { Stato } from 'features/ippica/types';
import { useTypedSelector } from 'lib/centralStore';
import { IppicaTipiScommessaRendererFilters } from './ippicaTipiScommessaRendererFilters/IppicaTipiScommessaRendererFilters';
import { IppicaTipiScommessaRendererResults } from './ippicaTipiScommessaRendererResults/IppicaTipiScommessaRendererResults';
import dynamic from 'next/dynamic';

export const DynamicIppicaTipiScommesseRenderer = dynamic(() =>
  import('features/ippica/components/ippicaTipiScommessaRenderer').then((mod) => mod.IppicaTipiScommessaRenderer)
);
export const IppicaTipiScommessaRenderer = () => {
  const codiceStatoAvvenimento = useTypedSelector(selectStatoAvvenimento);
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {/* if is in payment or closed */}
      {(isEqualStatoScommessaByKey(codiceStatoAvvenimento!, Stato.InPagamento) ||
        isEqualStatoScommessaByKey(codiceStatoAvvenimento!, Stato.Chiusa)) && <IppicaTipiScommessaRendererResults />}
      {/* if is opened */}
      {isEqualStatoScommessaByKey(codiceStatoAvvenimento!, Stato.Aperta) && <IppicaTipiScommessaRendererFilters />}
    </>
  );
};
